import * as amplitude from '@amplitude/analytics-browser';

export const initAmplitude = () => {
  if (typeof window === 'undefined') return;

  const apiKey = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;

  if (apiKey) {
    amplitude.init(apiKey, {
      minIdLength: 1,
      autocapture: {
        pageViews: true,
      },
    });
  } else {
    console.error('Amplitude API Key not found');
  }
};

export {amplitude};
